<div class="search-selector">
  <!-- {{options?.length}} -->
  <span class="search-icon" [inlineSVG]="'/icons/icon-search.svg'"></span>
  <mat-form-field [floatLabel]="'auto'">
    <input
      type="text"
      matInput
      (input)="onValueChange($event)"
      [value]="inputValue"
      [matAutocomplete]="autoComplete"
      [placeholder]="placeholder | transloco"
    />
    <span (click)="resetValue($event)" class="icon-close cta-btn" [inlineSVG]="'/icons/icon-close.svg'"></span>
    <mat-autocomplete
      #autoComplete="matAutocomplete"
      class="selector-mat-autocomplete"
      classlist="selector-mat-autocomplete"
    >
      <!-- <ng-container *ngIf="!optionsTemplate">
      <mat-option *ngFor="let option of options" class="selector-mat-option" (click)="optionClicked($event)">
        <ng-container *ngTemplateOutlet="defaultOptions; context: { option: option }"></ng-container>
      </mat-option>
    </ng-container> -->

      @for (option of options; track option) {
        <mat-option class="selector-mat-option global-no-checkbox" (click)="optionClicked($event)">
          <div class="option-content" (click)="optionClicked($event)">
            <ng-container *ngTemplateOutlet="optionTemplate || defaultRow; context: { option: option }"></ng-container>
          </div>
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
</div>

<ng-template #defaultRow let-option="option">
  <div>
    <p class="title">{{ option.key }}</p>
  </div>
  <button
    class="select-btn btn-primary btn-dark-theme cta-btn"
    (click)="select($event, option)"
    [disabled]="option?.selected"
    [class.btn-disabled]="option?.selected"
  >
    {{ option.selected ? ('global.selected' | transloco) : ('global.select' | transloco) }}
  </button>
</ng-template>
